import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CircularProgress from "@mui/material/CircularProgress";
import translations from '../components/translations';
import '../asset/styles/SubscriptionPage.css';

const API_BASE_URL = "https://2epfk2ien9.execute-api.eu-west-2.amazonaws.com/prd";

const SubscriptionPage = () => {
    const navigate = useNavigate();
    // const [language, setLanguage] = useState("en");
    const [language, setLanguage] = useState(localStorage.getItem("selectedLanguage") || "EN-US");
    // ✅ translations[language]가 없을 경우 기본값 설정
    const currentTranslations = translations[language] || translations["EN-US"];
    const [plans, setPlans] = useState([]);
    const [subscriptionStartDate, setSubscriptionStartDate] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const savedLanguage = localStorage.getItem("selectedLanguage");

        if (savedLanguage) setLanguage(savedLanguage);

        const fetchPlans = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/subscription-plans`);
                const data = await response.json();
                setPlans(data);
            } catch (error) {
                console.error("❌ Failed to fetch subscription plans:", error);
            }
        };

        fetchPlans();
    }, []);

    const handleSubscription = async (planId) => {
        if (loading) return;
        setLoading(true);

        const phoneNumber = localStorage.getItem("phone_number");
        const countryCode = localStorage.getItem("country_code");

        // ✅ 날짜가 `null` 또는 유효하지 않은 경우 체크
        if (!phoneNumber || !countryCode) {
            alert("❌ Missing phone number or country code.");
            setLoading(false);
            return;
        }

        if (!subscriptionStartDate || isNaN(new Date(subscriptionStartDate).getTime())) {
            alert("❌ Please select a valid subscription start date before proceeding.");
            setLoading(false);
            return;
        }

        // ✅ `Date` 객체로 변환 후 ISO 포맷 적용
        const formattedStartDate = new Date(subscriptionStartDate).toISOString().split("T")[0];

        try {
            const response = await fetch(`${API_BASE_URL}/create-checkout-session`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    phone_number: phoneNumber,
                    country_code: countryCode,
                    planId,
                    requested_start_date: formattedStartDate,
                }),
            });

            const result = await response.json();
            console.log("✅ Stripe Checkout URL:", result.sessionUrl);

            if (result.sessionUrl) {
                window.location.href = result.sessionUrl;
            } else {
                console.error("❌ Failed to get Checkout URL.");
                setLoading(false);
            }
        } catch (error) {
            console.error("❌ Failed to create checkout session:", error);
            setLoading(false);
        }
    };

    return (
        <div className="subscription-container">
            <h1 className="subscription-title">{currentTranslations.subscriptionTitle}</h1>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <div className="date-picker-container">
                    <label>{currentTranslations.subscriptionStartDate}:</label>
                    <DatePicker
                        value={subscriptionStartDate}
                        onChange={(newDate) => setSubscriptionStartDate(newDate || new Date())} // ✅ `null` 방지
                        format="yyyy-MM-dd"
                        minDate={new Date()}
                        renderInput={(params) => <input {...params} className="date-picker-input" />}
                    />
                </div>
            </LocalizationProvider>

            <div className="plans-container">
                {plans.length > 0 ? (
                    plans.map((plan) => (
                        <div key={plan.plan_id} className="plan-card">
                            <h3>{plan.plan_name}</h3>
                            <p>EUR {plan.price}</p>
                            <button
                                className="select-button"
                                onClick={() => handleSubscription(plan.plan_id)}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={20} color="inherit" /> : "SÉLECTIONNER"}
                            </button>
                        </div>
                    ))
                ) : (
                    <p>Loading plans...</p>
                )}
            </div>

            <button className="return-button" onClick={() => navigate(-1)}>RETOUR</button>
        </div>
    );
};

export default SubscriptionPage;
